import * as React from "react";
import { MessageBar, MessageBarType } from "@fluentui/react";
import { _Styles } from '../../content/styles/Page.styles';
import BackGround from '../../content/images/HomePage.png';
import { UIControlsText } from "../../content/UIControlsText";
import { SessionStorageConsts } from '../../models/SessionStorageConsts';
import { MessageTypeText } from '../../models/MessageTypeText';
import { getEntityDataFromSession, getRuleValidationMessage } from '../../components/shared/common/util';

const sessionResourceData = getEntityDataFromSession<any>(SessionStorageConsts.resourceStrings);
export const HomePage: React.FunctionComponent = () => {
    const showNotificationBanner: boolean = process.env.REACT_APP_MDPPBANNER_SHOW === 'true';
    const [onboardingPortalMessage, setOnboardingPortalMessage] = React.useState<string>("");

    React.useEffect(() => {
        const storedPortalMessage = sessionStorage.getItem(SessionStorageConsts.partnerCenterOnboardingPortalMessage) || "";
        setOnboardingPortalMessage(storedPortalMessage);
    }, []);

    const dismissOnboardingPortalMessage = () => {
        sessionStorage.removeItem(SessionStorageConsts.partnerCenterOnboardingPortalMessage);
        setOnboardingPortalMessage("");
    }

    return (
        <div>
            <div className={_Styles.homePageStyle}>
                {onboardingPortalMessage &&
                    <div
                        style={{
                            marginLeft: '20px',
                            marginRight: '20px',
                            marginTop: '8px',
                            backgroundColor: '#FFF19D',
                            border: '1px solid #DDDDDD',
                            padding: '8px 12px',
                            textAlign: 'left',
                        }}
                    >
                        <MessageBar
                            messageBarType={MessageBarType.warning}
                            isMultiline={true}
                            dismissButtonAriaLabel="Close"
                            onDismiss={dismissOnboardingPortalMessage}
                            styles={{
                                root: {
                                    fontSize: '15px',
                                    backgroundColor: '#f3f2f1',
                                    border: '1px solid #d2d0ce',
                                    textAlign: 'left',
                                },
                                content: {
                                    backgroundColor: '#f3f2f1',
                                },
                                icon: {
                                    color: '#605e5c',
                                    backgroundColor: '#f3f2f1',
                                },
                                text: {
                                    backgroundColor: '#f3f2f1',
                                },
                                innerText: {
                                    backgroundColor: '#f3f2f1',
                                },
                                dismissal: {
                                    backgroundColor: '#f3f2f1',
                                },
                                dismissSingleLine: {
                                    backgroundColor: '#f3f2f1',
                                },
                            }}
                        >
                            <div
                                style={{
                                    fontSize: '15px',
                                    backgroundColor: '#f3f2f1',
                                    textAlign: 'left',
                                    lineHeight: 1.4,
                                }}
                                dangerouslySetInnerHTML={{ __html: onboardingPortalMessage }}
                            />
                        </MessageBar>
                    </div>
                }
                {
                    showNotificationBanner &&
                    <div className={[_Styles.bannerNotificationStyle, _Styles.bannerNotificationCenter, _Styles.bannerNotificationMargin].join(" ")}>
                        <div className={_Styles.bannerNotificationMargin}>
                            <span className={[_Styles.bannerNotificationCenter, _Styles.bannerHeaderFont].join(" ")}><b>Important Message</b></span>
                            <div className={_Styles.bannerNotificationHdrLabel}>Transition Notification Banner on MDPP Portal Homepage:</div>
                            <div className={_Styles.bannerNotificationLabel}>{UIControlsText.MDPPTransitionBannerNotificationText}</div><br />
                        </div>
                    </div>
                }
                <img src={BackGround} style={{ height: "100%", width: "100%" }} alt={UIControlsText.HomePageImage} />
            </div>
        </div>
    )
}